import { createContext, useContext, useState } from 'react';

const LanguageSwitchContext = createContext();

export const useLanguageSwitch = () => useContext(LanguageSwitchContext);

export const LanguageSwitchProvider = ({ children }) => {
	const [isLangSwitchEnabled, setIsLangSwitchEnabled] = useState(true);

	return (
		<LanguageSwitchContext.Provider value={{ isLangSwitchEnabled, setIsLangSwitchEnabled }}>
			{children}
		</LanguageSwitchContext.Provider>
	);
};
